import { Certification } from "../types";

export const certifications: Certification[] = [
  {
    title: "Orbital - Apollo 11 (Advanced)",
    issuer: "National University of Singapore",
    issuedDate: "2023-08-23",
    link: "https://credentials.nus.edu.sg/10db38ff-4850-4ce9-b046-f77441bca590#acc.s2zfoSkR",
    iconName: "university",
  },
  {
    title: "Developing Front-End Apps with React",
    issuer: "IBM",
    issuedDate: "2023-11-15",
    link: "https://www.coursera.org/account/accomplishments/verify/GSSUSNJZK9TZ",
    iconName: "coursera",
  },
  {
    title: "Algorithmic Trading & Quantitative Analysis Using Python",
    issuer: "Udemy",
    issuedDate: "2021-12-20",
    link: "https://ude.my/UC-a202f370-d7dd-45eb-b69c-a13d994b9ef2",
    iconName: "udemy",
  },
  {
    title: "JavaScript Algorithms and Data Structures",
    issuer: "Udemy",
    issuedDate: "2021-08-05",
    link: "https://ude.my/UC-c2562903-4d8e-4658-95e4-e2b2396f218a",
    iconName: "udemy",
  },
];
